export const TASK_TITLE_INPUT_DEBOUNCE_DELAY_MS = 1000;
export const TASK_TITLE_INPUT_PLACEHOLDER = "Add a task";
export const TASK_TITLE_INPUT_MIN_HEIGHT = 21;
export const TASK_TITLE_INPUT_MAX_HEIGHT = 400;

// This is the placeholder tag ID used for the unassigned tag in the radio button list
// Note: this is only used on the client
export const DEFAULT_TAG_ID = "default-tag";
